var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgComparison = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M10 15.944c0-.617.052-.333-3.323-6.932-.69-1.348-2.664-1.35-3.354 0C-.08 15.668 0 15.346 0 15.944 0 17.632 2.239 19 5 19c2.761 0 5-1.368 5-3.056zm-4.553-5.05l2.191 4.382a.5.5 0 0 1-.447.724H2.809a.5.5 0 0 1-.447-.724l2.19-4.382a.5.5 0 0 1 .895 0zm17.23-1.882c-.69-1.348-2.664-1.35-3.354 0C15.92 15.668 16 15.346 16 15.944 16 17.632 18.239 19 21 19c2.761 0 5-1.368 5-3.056 0-.617.052-.333-3.323-6.932zm-4.315 6.264l2.19-4.382a.5.5 0 0 1 .895 0l2.191 4.382a.5.5 0 0 1-.447.724h-4.382a.5.5 0 0 1-.447-.724zm2.995 8.224h-7.071V5.986c.944-.402 1.653-1.23 1.864-2.236h5.207c.355 0 .643-.28.643-.625v-1.25a.634.634 0 0 0-.643-.625h-5.8A3.23 3.23 0 0 0 13 0a3.23 3.23 0 0 0-2.557 1.25h-5.8A.634.634 0 0 0 4 1.875v1.25c0 .345.288.625.643.625H9.85c.21 1.006.92 1.834 1.864 2.236V23.5H4.643a.634.634 0 0 0-.643.625v1.25c0 .345.288.625.643.625h16.714c.355 0 .643-.28.643-.625v-1.25a.634.634 0 0 0-.643-.625z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgComparison);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/comparison.a877a0b5803a52a4a499d9a69fb81a46.svg";